interface TrialBalanceRow {
  debitsYtd?: number;
  creditsYtd?: number;
}

interface TotalRow {
  debitsYtd: number;
  creditsYtd: number;
}

export default function createTrialBalanceRow(
  rows: Array<TrialBalanceRow>,
): TotalRow {
  return {
    debitsYtd: rows.reduce((sum, row) => sum + (row.debitsYtd || 0), 0),
    creditsYtd: rows.reduce((sum, row) => sum + (row.creditsYtd || 0), 0),
  };
}
